import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import PreTripItemCreate from './PreTripItemCreate';
import PreTripItemList from './PreTripItemList';

const PreTripItems = (props) => {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/items/category/:id`}>
                <PreTripItemList {...props} />
            </Route>
            <Route path={`${path}/items/category`}>
                <PreTripItemList {...props} />
            </Route>
            <Route path={`${path}/items/create`}>
                <PreTripItemCreate {...props} />
            </Route>
            <Route path={`${path}/items/:id`}>
                <PreTripItemList {...props} />
            </Route>
            <Route path={`${path}/items`}>
                <PreTripItemList {...props} />
            </Route>
        </Switch>
    );
};

export default PreTripItems;
